import { render, staticRenderFns } from "./GridContainer.vue?vue&type=template&id=271b0b07&"
import script from "./GridContainer.vue?vue&type=script&lang=js&"
export * from "./GridContainer.vue?vue&type=script&lang=js&"
import style0 from "./GridContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/owiwi.co.uk/staging.appraisal.owiwi.co.uk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('271b0b07', component.options)
    } else {
      api.reload('271b0b07', component.options)
    }
    module.hot.accept("./GridContainer.vue?vue&type=template&id=271b0b07&", function () {
      api.rerender('271b0b07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GridContainer/GridContainer.vue"
export default component.exports